"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoCarouselNavControls = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _index = require("../Icon/index");
var _IconButton = require("../IconButton/IconButton");
var _PhotoCarouselNavControls = require("./PhotoCarouselNavControls.styles");
/**
 * The "Previous photo" and "Next photo" nav buttons that appear on hover.
 *
 * @related ['IconButton']
 * @since 8.66.0
 */
var PhotoCarouselNavControls = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var leftButtonProps = _ref.leftButtonProps,
    rightButtonProps = _ref.rightButtonProps;
  return /*#__PURE__*/_react.default.createElement(_PhotoCarouselNavControls.StyledPhotoCarouselNavControls, {
    ref: forwardedRef
  }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, (0, _extends2.default)({
    "aria-hidden": true,
    as: "span",
    bare: false,
    buttonType: "secondary",
    icon: /*#__PURE__*/_react.default.createElement(_index.IconChevronLeft, null),
    inverse: true,
    title: "Previous photo"
  }, leftButtonProps)), /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, (0, _extends2.default)({
    "aria-hidden": true,
    as: "span",
    bare: false,
    buttonType: "secondary",
    icon: /*#__PURE__*/_react.default.createElement(_index.IconChevronRight, null),
    inverse: true,
    title: "Next photo"
  }, rightButtonProps)));
});
exports.PhotoCarouselNavControls = PhotoCarouselNavControls;
PhotoCarouselNavControls.displayName = 'PhotoCarouselNavControls';
PhotoCarouselNavControls.propTypes = {
  /**
   * Props passed by `PhotoCarousel`. Contains `onClick` and `disabled`.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  leftButtonProps: _propTypes.default.object,
  /**
   * Props passed by `PhotoCarousel`. Contains `onClick` and `disabled`.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  rightButtonProps: _propTypes.default.object
};